import styled from 'styled-components/macro';

export const MutedText = styled.small`
  color: #6c757d !important;
  display: block;
  font-size: 80%;
  font-weight: 400;
  margin-top: 0.25rem;
`;
